<template lang="pug">
	Component(v-bind="layoutAttrs" :is="DefaultLayoutWithVerticalNav")
		slot
</template>

<script lang="ts" setup>
import { switchToVerticalNavOnLtOverlayNavBreakpoint } from "@layouts/utils"

const DefaultLayoutWithVerticalNav = defineAsyncComponent(() => import("./components/DefaultLayoutWithVerticalNav.vue"))

switchToVerticalNavOnLtOverlayNavBreakpoint()

const { layoutAttrs, injectSkinClasses } = useSkins()

injectSkinClasses()
</script>
